export default {
  heading: {
    widgetName: "Hotels",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Promotions | BigPay`,
      eventLabelCardClick: `BigPay | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `BigPay | headline | {{headline}}`,
      eventLabelView: `BigPay Promotions MS`,
    },
  },


  data: [
    {
      primaryLabel: '',
      image: "https://www.airasia.com/aa/bigpay/images/aa-bigpay-flight-EN.png",
      title: "Terbang ke destinasi kegemaran anda!",
      subtitle: "Tempah penerbangan dan jelajahilah Asia Tenggara dan selebihnya",
      cta: "Tempah sekarang!",
      url: "https://www.airasia.com/promotions/flights/",
    },
    // {
    //   primaryLabel: '',
    //   image: "https://www.airasia.com/aa/bigpay/images/aa-bigpay-shop-EN.png",
    //   title: "Riang ria membeli belah",
    //   subtitle: "Lihat pilihan hebat produk bebas-cukai kami",
    //   cta: "Beli sekarang",
    //   url: "https://www.airasia.com/promotions/#shop",
    // },
    {
      primaryLabel: '',
      image: "https://www.airasia.com/aa/bigpay/images/aa-bigpay-hotel-EN.png",
      title: "Promo hotel tanpa bandingan",
      subtitle: "Nikmati tawaran hebat daripada lebih 600,000 hotel di serata dunia",
      cta: "Tempah sekarang!",
      url: "https://www.airasia.com/promotions/hotels/",
    },
    {
      primaryLabel: '',
      image: "https://www.airasia.com/aa/bigpay/images/aa-bigpay-transport-en.png",
      title: "Bas, Tren dan Feri",
      subtitle: "Tempah dengan lebih daripada 4,000 pengusaha yang diyakini",
      cta: "Tempah sekarang!",
      url: "https://www.airasia.com/promotions/#transport",
    }
  ],
}
